import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("prod_"), S.String).pipe(S.annotations({
    identifier: "@open-revenue/schema/stripe/ProductId",
    description: "The id of the product in Stripe",
    examples: [
        "prod_1234567890"
    ]
}));
export const make = (productId)=>S.decodeUnknown(Schema)(productId);
export const makeUnsafe = (productId)=>productId;
